import React from 'react'
import { useHasRole } from './useAdminAuth'

interface PermissionGuardProps {
  requiredRole: string
  children: React.ReactNode
  fallback?: React.ReactNode
}

export function PermissionGuard({ requiredRole, children, fallback }: PermissionGuardProps) {
  const hasRole = useHasRole(requiredRole)

  if (!hasRole) {
    return (
      fallback ?? (
        <div className="flex items-center justify-center min-h-screen bg-slate-50">
          <div className="text-center p-8 bg-white rounded-xl shadow-lg max-w-md">
            <i className="pi pi-lock text-5xl text-red-400 mb-4" />
            <h2 className="text-xl font-bold text-slate-800 mb-2">Access Denied</h2>
            <p className="text-slate-500">
              You do not have the <code className="bg-slate-100 px-2 py-1 rounded text-sm">{requiredRole}</code> role
              required to access the Admin Console.
            </p>
            <p className="text-slate-400 mt-4 text-sm">
              Contact your platform administrator to request access.
            </p>
          </div>
        </div>
      )
    )
  }

  return <>{children}</>
}
